import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import RecentFiles from "./recentFiles";
import { base_url } from "../../../base_urls";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import NotFreeModal from "../../../components/modelpopup/NotFreeModal";
import JobModelPopup from "../../../components/modelpopup/JobModelPopup";

const FilesAi = ({ triggerUploadFromSearch }) => {
  const [filesvalues, setFilesValues] = useState([]);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [triggerUpload, setTriggerUpload] = useState(false);
  const [modaldata, setModaldata] = useState([]);
  const { fileSize, lastModified } = formatFileInfo(uploadedFile || "");
  const [fileValue, setFileValue] = useState("");

  const { t, i18n } = useTranslation();
  useEffect(() => {
    axios
      .get(base_url + "api/aiAnalysisSamples/BookBotFileSamples.json")
      .then((res) => setFilesValues(res.data))
      .catch((err) => console.log(err));
  }, []);

  const [resetSearch, setResetSearch] = useState(false);

  const handleResetChild = () => {
    setResetSearch(true);
    setUploadedFile(null);
    setTriggerUpload(false);
  };

  const handleFileUpload = (file) => {
    // console.log("File received in parent:", file);
    setUploadedFile(file);
  };
  const triggerChildFileUpload = () => {
    setTriggerUpload(true);
    setTimeout(() => setTriggerUpload(false), 100); // Reset after trigger
  };

  useEffect(() => {
    if (resetSearch) {
      setResetSearch(false);
    }
  }, [resetSearch]);

  function formatFileInfo(file) {
    const sizeInKB = file.size / 1024;
    const readableSize =
      sizeInKB < 1024
        ? `${sizeInKB.toFixed(2)} KB`
        : `${(sizeInKB / 1024).toFixed(2)} MB`;

    const date = new Date(file.lastModified);
    const options = {
      day: "2-digit",
      month: "short",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };
    const readableDate = date.toLocaleString("en-US", options); // Or use 'ar-EG', 'he-IL' etc. for localization

    return {
      fileSize: readableSize,
      lastModified: readableDate,
    };
  }

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <div className="file-wrap">
            <div className="file-cont-wrap w-100 me-0">
              <div className="file-cont-inner">
                <div className="file-cont-header justify-content-start  gap-3">
                  <span>ارفع ملف للفحص </span>
                  <div className="d-flex gap-2">
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#apply_job"
                      className="btn   btn-outline-primary"
                    >
                      <i className="la la-upload"></i> المستشار المالي
                    </Link>
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#apply_job"
                      className="btn  btn-outline-success"
                    >
                      <i className="la la-upload"></i>
                      المستشار القضائي
                    </Link>
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#apply_job"
                      className="btn  btn-outline-warning"
                    >
                      <i className="la la-upload"></i>
                      مستشار الضرائب
                    </Link>

                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#apply_job"
                      className="btn  btn-outline-danger"
                    >
                      <i className="la la-upload"></i>
                      محلل البيانات
                    </Link>
                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#apply_job"
                      className="btn  btn-outline-light"
                    >
                      <i className="la la-upload"></i>
                      مستشار KYC
                    </Link>

                    <Link
                      to="#"
                      data-bs-toggle="modal"
                      data-bs-target="#apply_job"
                      className="btn  btn-outline-dark active"
                    >
                      <i className="la la-upload"></i>
                      أرشيف
                    </Link>
                  </div>
                  {/* <JobModelPopup /> */}
                  <NotFreeModal
                    modalId="apply_job"
                    title="المستشار و المحلل الذكي "
                    content="الخدمة غير متاحة   في النسخة المجانية  ! "
                  />
                </div>
                <div className="file-content">
                  <div className="file-body">
                    <div className="file-scroll ai-file ">
                      <div className="file-content-inner">
                        {!uploadedFile && (
                          <>
                            <h3 className=" p-2 ">
                              مستندات مالية قابلة للتحليل بواسطة
                              <span className="text-primary"> Mass Ai </span>
                            </h3>
                            <hr />
                            <div className="row row-sm justify-content-start ">
                              {filesvalues.map((file, index) => (
                                <div
                                  className="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3"
                                  key={index}
                                >
                                  {/* <div className="card card-file">
                                    <div className="card-file-thumb text-primary">
                                      <i className={file.icon} />
                                    </div>
                                    <div className="card-body">
                                      <h6>
                                        <Link
                                          to="#"
                                          onClick={() => {
                                            setFileValue(file);
                                            triggerChildFileUpload();
                                          }}
                                          className="pb-2"
                                          data-tooltip-id="description-tooltip"
                                          data-tooltip-content={
                                            t(i18n.language) == "ar"
                                              ? file.description_ar
                                              : file.description_en
                                          }
                                        >
                                          {t(i18n.language) == "ar"
                                            ? file.reportName_ar
                                            : file.reportName_en}
                                        </Link>
                                      </h6>
                                    </div>
                                    <div className="card-footer">
                                      <span className="d-none d-sm-inline"></span>
                                    </div>
                                  </div> */}
                                  <div className="card card-file group">
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        setFileValue(file);
                                        triggerUploadFromSearch();
                                      }}
                                      className="card-file-thumb-link"
                                    >
                                      <div className="card-file-thumb text-primary">
                                        <i className={file.icon} />
                                        {/* <span className="upload-hover-label">
                                          Upload
                                        </span> */}
                                      </div>
                                    </Link>

                                    <div className="card-body">
                                      <h6>
                                        <Link
                                          to="#"
                                          onClick={() => {
                                            setFileValue(file);
                                            triggerUploadFromSearch();
                                          }}
                                          className="pb-2"
                                          data-tooltip-id="description-tooltip"
                                          data-tooltip-content={
                                            t(i18n.language) == "ar"
                                              ? file.description_ar
                                              : file.description_en
                                          }
                                        >
                                          {t(i18n.language) == "ar"
                                            ? file.reportName_ar
                                            : file.reportName_en}
                                        </Link>
                                      </h6>
                                    </div>

                                    <div className="card-footer">
                                      <span className="d-none d-sm-inline"></span>
                                    </div>
                                  </div>

                                  <Tooltip
                                    id="description-tooltip"
                                    place="top"
                                    className="description-tooltip"
                                  />
                                </div>
                              ))}
                            </div>
                            <hr />
                          </>
                        )}
                        <h4 className="text-primary">
                          {uploadedFile ? " الملف الحالي " : "الملفات الحديثة"}{" "}
                        </h4>
                        {uploadedFile && (
                          <div className="row row-sm justify-content-start ">
                            <div className="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3 mt-2">
                              <div className="card card-file">
                                <div className="dropdown-file">
                                  <Link
                                    to="#"
                                    className="dropdown-link  "
                                    data-bs-toggle="dropdown"
                                  >
                                    <i className="fa fa-ellipsis-v" />
                                  </Link>
                                  <div className="dropdown-menu dropdown-menu-right text-end">
                                    <Link to="#" className="dropdown-item">
                                      عرض التفاصيل
                                    </Link>
                                    <Link to="#" className="dropdown-item">
                                      مشاركة
                                    </Link>
                                    <Link to="#" className="dropdown-item">
                                      تحميل
                                    </Link>
                                    <Link to="#" className="dropdown-item">
                                      إعادة تسمية
                                    </Link>
                                    <Link to="#" className="dropdown-item">
                                      حذف
                                    </Link>
                                  </div>
                                </div>
                                <div className="card-file-thumb text-primary">
                                  <i
                                    className={`${
                                      uploadedFile.name.match(/\.(pdf)$/i)
                                        ? "fa-regular fa-file-pdf"
                                        : uploadedFile.name.match(
                                            /\.(doc|docx)$/i
                                          )
                                        ? "fa-regular fa-file-word"
                                        : uploadedFile.name.match(
                                            /\.(jpg|jpeg|png|gif)$/i
                                          )
                                        ? "fa-regular fa-file-image"
                                        : uploadedFile.name.match(
                                            /\.(xls|xlsx)$/i
                                          )
                                        ? "fa-regular fa-file-excel"
                                        : "fa-regular fa-file"
                                    } me-2`}
                                  />
                                </div>
                                <div className="card-body">
                                  <h6>
                                    <Link to="#">{uploadedFile?.name}</Link>
                                  </h6>
                                  <span>{fileSize || ""}</span>
                                </div>
                                <div className="card-footer">
                                  <span className="d-none d-sm-inline"></span>
                                  {lastModified || ""}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilesAi;
